export const insightTypeDictionnary = {
  positive: 'positive',
  negative: 'negative',
  improvement: 'improvement',
  behavior: 'behavior',
  motivation: 'motivation'
};